import React from 'react';
import { FaCopy } from 'react-icons/fa';
import { Button } from '@/components/ui/button';

interface CopyButtonProps {
  textToCopy: string;
  disabled?: boolean;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ 
  textToCopy, 
  disabled = false 
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(textToCopy)
      .catch(() => {
        // Fallback for browsers that don't support clipboard API
        const tempInput = document.createElement("textarea");
        tempInput.value = textToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      });
  };

  return (
    <Button 
      variant="ghost"
      size="sm"
      onClick={handleCopy} 
      disabled={disabled}
      className="h-6 px-2 text-xs"
    >
      <FaCopy className="mr-1 h-3 w-3" />
      Copy
    </Button>
  );
};